import React from "react";
import { useState, useEffect, useRef } from "react";
import LoadingBar from "react-top-loading-bar";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import Image2PdfImagesListScreen from "./Image2PdfImagesListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function Image2PdfMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Convert PNG, WEBP, SVG, BMP, JPEG, JPG to PDF",
  };
  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/image_to_pdf", title: "Image to PDF" },
    data2: { link: "/image_to_pdf", title: "PNG to PDF" },
    data3: { link: "/image_to_pdf", title: "Photo to PDF online" },
  };

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Convert images to PDF online instantly. Turn JPG, PNG, or photos into high quality PDFs quickly with our fast and secure image to PDF converter."
      ></meta>
      <meta
        name="keywords"
        content="image to pdf, image to pdf converter, convert image to pdf, jpg to pdf, png to pdf, photo to pdf, images to pdf online, online image to pdf, picture to pdf, image pdf converter, convert photos to pdf, image to pdf tool, image to pdf free, pdf creator from images, photo pdf maker"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <Image2PdfImagesListScreen title={title}></Image2PdfImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our offline Image to PDF, WEBP to PDF, SVG to PDF, BMP to PDF, JPEG to PDF, JPG to PDF and PNG to PDF Converter is a secure, high-performance solution designed for users who need fast and reliable image conversion without an internet connection. This powerful offline image to PDF converter allows you to easily convert WEBP, JPG, JPEG, PNG, BMP, and TIFF images into high-quality PDF files while maintaining original resolution and formatting. Ideal for professionals, students, and businesses, a JPG to PDF converter offline and PNG to PDF converter offline ensures complete data privacy, making it perfect for handling sensitive documents, scanned files, photos, receipts, and reports. With features such as batch image conversion, adjustable page size and orientation, image compression, drag-and-drop support, and multi-image merging into a single PDF, this free offline image to PDF converter delivers maximum efficiency and productivity. Unlike online tools, an offline photo to PDF converter works seamlessly on desktop and mobile devices without uploads or cloud storage, offering faster processing and full control over your files. Whether you need to convert images to PDF for printing, archiving, or sharing, this JPG, PNG to PDF converter offline is an essential document management tool that provides secure, accurate, and high-quality image to PDF conversion offline for everyday and professional use." />
          {/* How to use define max 4 steps */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Convert",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Image to PDF converter"
            why_use={[
              {
                title: "Universal and Standard File Format",
                description:
                  "Our image to PDF converter helps create PDF files that work smoothly on all devices and operating systems, making JPG to PDF and PNG to PDF conversion ideal for universal file sharing.",
              },
              {
                title: "Better File Organization",
                description:
                  "Using an image to PDF converter offline or online, you can combine multiple JPEG, WEBP, SVG, BMP, JPG and PNG images into a single PDF for improved document management and easy storage.",
              },
              {
                title: "Professional Document Presentation",
                description:
                  "This JPG to PDF converter transforms images into clean, professional-looking PDF documents suitable for business, office work, and academic submissions.",
              },

              {
                title: "Easy Sharing and Printing",
                description:
                  "PDFs generated using a PNG to PDF converter maintain layout and quality, ensuring perfect results when printing or sharing via email and cloud platforms.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Our powerful image to PDF converter supports JPG, JPEG, PNG, BMP, WEBP, SVG and other formats, making photo to PDF conversion quick and hassle-free.",
              },
              {
                title: "Reduced File Size and Optimization",
                description:
                  "Our free image to PDF converter can compress images efficiently, reducing PDF file size while preserving image clarity for faster uploads and downloads.",
              },
              {
                title: "Improved Security and Privacy",
                description:
                  "PDF files created using a WEBP, BMP, SVG, JPG, PNG to PDF converter can be password-protected, offering better security than standard image files.",
              },
              {
                title: "Offline Conversion Capability",
                description:
                  "This offline image to PDF converter allows users to convert JPG to PDF and PNG to PDF without internet access, ensuring data privacy and faster processing.",
              },
              {
                title: "Perfect for Scanned Documents and Photos",
                description:
                  "Our photo to PDF converter is ideal for converting scanned images, receipts, invoices, and documents into searchable, shareable PDF files.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I convert JPG to PDF online for free?",
                description:
                  "Visit ShivaPDF.com and open the JPG to PDF converter. Select your JPG or JPEG images, adjust the available page settings, and start the conversion. Download the resulting PDF to your device when it is ready.",
              },
              {
                title: "Can I convert JPG to PDF offline?",
                description:
                  "You can convert JPG images to PDF offline if the converter and all required resources are available locally on your device. You may need an internet connection to load the tool initially if its scripts or other resources are not stored locally.",
              },
              {
                title: "Can I convert JPG to PDF without uploading my images?",
                description:
                  "If ShivaPDF processes images entirely in your browser, you can convert JPG files to PDF without uploading them to a remote server. Local processing can help protect the privacy of personal photos and confidential documents.",
              },
              {
                title: "Is it safe to convert JPG to PDF locally?",
                description:
                  "Local conversion can help protect your privacy because your images do not need to be sent to a remote server. If you are converting sensitive images, verify that the tool performs the conversion locally and does not transmit your files.",
              },
              {
                title: "What is a JPG to PDF converter?",
                description:
                  "A JPG to PDF converter turns JPG or JPEG images into a PDF document. This is useful for combining photos, scanned documents, receipts, certificates, and other images into a file that is easy to share, print, and store.",
              },
              {
                title: "Can I convert multiple JPG images into one PDF?",
                description:
                  "Yes, if multiple-image selection is supported, you can combine several JPG images into a single PDF document. This is useful for creating a PDF from scanned pages, receipts, photographs, or document images.",
              },
              {
                title: "Can I convert one JPG image into a PDF?",
                description:
                  "Yes, a single JPG image can be converted into a PDF containing that image on a page. This is useful for sharing a photograph, scanned form, certificate, or other image in PDF format.",
              },
              {
                title: "Can I convert JPEG to PDF?",
                description:
                  "Yes, JPG and JPEG are commonly used extensions for the same image format. If the converter supports JPEG images, you can select a .jpg or .jpeg file and convert it into a PDF.",
              },
              {
                title: "Can I choose the order of images in a PDF?",
                description:
                  "If the tool supports image reordering, you can arrange your selected images in the desired sequence before conversion. Review the order carefully to ensure the pages appear correctly in the final PDF.",
              },
              {
                title: "Can I choose portrait or landscape orientation?",
                description:
                  "Page orientation options depend on the converter's features. If supported, choose portrait or landscape to match the image dimensions and the way you want the PDF to appear when viewed or printed.",
              },
              {
                title: "Can I adjust the page size when converting JPG to PDF?",
                description:
                  "If page size settings are available, you may be able to choose a standard size such as A4 or Letter, or use a page layout that fits the image. Check the conversion options to see which page sizes and margins are supported.",
              },
              {
                title: "Will converting JPG to PDF reduce image quality?",
                description:
                  "The resulting quality depends on the conversion method, image resolution, and any compression applied. To preserve detail, use high-quality source images and check whether the converter provides image quality or compression settings.",
              },
              {
                title: "Can I convert JPG to PDF without losing resolution?",
                description:
                  "A PDF can retain the original image resolution when the converter embeds the image without downsampling it. The result depends on the tool's settings, so review the output if preserving fine details is important.",
              },
              {
                title: "Can I convert JPG images to PDF on my phone?",
                description:
                  "You can access ShivaPDF.com through a supported browser on an iPhone, Android phone, or tablet. Select images from your device and use the available conversion options to create a PDF.",
              },
              {
                title: "Do I need to install software to convert JPG to PDF?",
                description:
                  "No separate desktop application is required when using a browser-based JPG to PDF converter. Open ShivaPDF.com in a supported browser, select your images, and follow the available steps to create your PDF.",
              },
              {
                title: "Can I convert JPG to PDF without creating an account?",
                description:
                  "You can use the converter without registering if ShivaPDF does not require an account for this feature. Check the JPG to PDF page for any current access requirements or usage limits.",
              },
              {
                title: "Can I convert large JPG images to PDF?",
                description:
                  "Large images may require additional memory and processing time during conversion. The maximum supported file size depends on the tool's limits, image dimensions, and your device's available resources.",
              },
              {
                title: "Can I convert JPG images into a searchable PDF?",
                description:
                  "Converting JPG images directly to PDF generally creates pages containing images rather than searchable text. To make text searchable, you need OCR (optical character recognition), if that feature is available separately.",
              },
              {
                title: "Will the original JPG images be changed after conversion?",
                description:
                  "Converting JPG images to PDF should create a separate PDF file without requiring you to overwrite the original images. Keep the original files if you want to retain them in their original format.",
              },
              {
                title: "Why is my JPG to PDF file too large?",
                description:
                  "The PDF size depends on the number of images, their resolution, and the compression method. If the PDF is too large, try using appropriately sized images or a separate PDF compression tool while balancing file size and visual quality.",
              },
              {
                title: "How do I download my converted PDF?",
                description:
                  "After the conversion finishes, select the download option to save the PDF to your device. Open the downloaded document to confirm that all images appear correctly and that the page order and orientation are right.",
              },
              {
                title: "Why should I use ShivaPDF to convert JPG to PDF?",
                description:
                  "ShivaPDF provides browser-based PDF tools that help you manage documents without installing separate desktop software. Use the JPG to PDF converter to combine supported images into a PDF for sharing, printing, and archiving.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1599994703}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default Image2PdfMain;
